import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyItFailed } from './components/WhyItFailed';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusesSection } from './components/BonusesSection';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferBlock } from './components/OfferBlock';
import { SponsorsSection } from './components/SponsorsSection';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen font-sans bg-cream selection:bg-accent selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <SponsorsSection variant="cream" data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <WhyItFailed data-id="element-5" />
        <UniqueMethod data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <WhoIsItFor data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <ProofSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <SponsorsSection variant="light" data-id="element-13" />
        <OfferBlock data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}